/**
 * Represents all of the available CSS styles for KCF designs
 */

export enum KCFStyle {
    primaryBoxShadow = '0 0 5px rgba(0, 0, 0, 0.05)',
    menuBoxShadow = '0 0 10px rgba(0, 0, 0, 0.2)',
    modalBoxShadow = '0 0 30px rgba(0, 0, 0, 0.15)',

    /**
     * similar to menuBoxShadow, but a drop-shadow filter config, e.g. for svgs.
     */
    menuDropShadow = '0 0 10px rgba(0 0 0 / 0.2)',
}
